import { create } from "zustand"

// Note: This store is mainly using for storing information that only using on the client.
// The data will be kept on current session only, and will be removed when the user close the tab.
interface ClientSetting {
  tab: string
  activityTab: string
  navigateTo: string | null

  changeNavigateTo: (navigateTo: string | null) => void
  changeTab: (tab: string) => void
  changeActivityTab: (activityTab: string) => void
  reset: () => void
}

const initialClientSetting = {
  tab: "xyz.be.customer://ride/home",
  navigateTo: null,
  activityTab: "transport",
}

const useClientSessionSetting = create<ClientSetting>((set) => ({
  ...initialClientSetting,
  changeTab(tab) {
    set({ tab })
  },

  changeActivityTab(activityTab) {
    set({ activityTab })
  },
  changeNavigateTo(navigateTo) {
    set({ navigateTo })
  },
  reset() {
    set({
      navigateTo: null,
      tab: initialClientSetting.tab,
    })
  },
}))

export { useClientSessionSetting }
